import { styled } from '@styles/stitches';

export const Creators = styled('div', {
  display: 'flex',
  marginRight: 8,

  '& > *': {
    marginLeft: -16,

    '&:first-child': {
      marginLeft: 0,
    },
  },
});
